/* eslint-disable react/prop-types */
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { weUserImage2 } from 'data/weraise-data/donar-data';
import React from 'react';
import { Card, Form } from 'react-bootstrap';

const ADSelectDonor = ({ title = 'Select Donor', editable = true }) => {
  return (
    <Card className="mb-3">
      <Card.Header className="pb-0">
        <Card.Title className="fw-medium">{title}</Card.Title>
      </Card.Header>
      <Card.Body>
        {editable && (
          <Form.Group className="mb-3" controlId="Donor_Name">
            <Form.Label>Donor Name</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Zahran Amir Bassam"
            />
            <Form.Control.Feedback type="invalid">
              Donor Name required
            </Form.Control.Feedback>
          </Form.Group>
        )}

        <Flex
          className={'border p-3 rounded-3'}
          alignItems="center"
          justifyContent={'between'}
        >
          <Flex alignItems={'center'}>
            <Avatar src={weUserImage2} size="3xl" />
            <div className="ms-3">
              <p className="mb-0 fw-medium">Zahran Amir Bassam</p>
              <p className="mb-0 fs--1 text-400 fw-medium">
                Score: <span className="text-success">876</span>
              </p>
            </div>
          </Flex>
          {editable && (
            <IconButton icon={'pen'} variant="outline-primary">
              <span className="d-none d-md-inline-block">Change</span>
            </IconButton>
          )}
        </Flex>
      </Card.Body>
    </Card>
  );
};

export default ADSelectDonor;
